import { useIntl } from 'react-intl'

import { StyledFadeInWrapper } from 'components/Layout/CommonLayout/styles'
import { HomeActiveConfig, HomeConfigFiles, HomeDeploymentsHistory } from '../'
import { usePollForHomeConfigUpdates } from './utils'
import { HomeConfigurationContainer } from './styles'
import { homeConfigurationMessages } from './messages'
import { H1 } from 'components/Typography/Headings'

// TODO: Localization
function HomeConfiguration() {
  const { formatMessage } = useIntl()

  usePollForHomeConfigUpdates()

  return (
    <StyledFadeInWrapper>
      <H1>Configuration</H1>
      <HomeConfigurationContainer>
        <HomeActiveConfig />
        <HomeConfigFiles
          selector="matching"
          title={formatMessage(homeConfigurationMessages.configFilesTableTitle)}
        />
        <HomeDeploymentsHistory />
      </HomeConfigurationContainer>
    </StyledFadeInWrapper>
  )
}

export default HomeConfiguration
